import { HistogramData } from "../../constants/types";

export default class HistogramService {
    async getHistogramData(
        input: HistogramData
    ) {
        const isSrc = window.location.hostname === 'src2.fincalc.cz'
        const endpoint = isSrc ? "https://src2data.fincalc.cz/data/phpscripts/histogram_data.php" : "https://phpscripts.fincalc.cz/histogram_data.php";

        const endYear = Number(input.endYear) - Number(input.due);
        const finalEndpoint = 
            `${endpoint}?sloupec=${input.accountForInflation === "true" ? "Real":"Nom"}${input.investmentType === "oneTime" ? "Jed":"Prav"}&horizont=${input.due}&akcie=${input.shares}&dluhopisy=${input.bonds}&start=${input.beginningYear}&end=${endYear.toString()}`
        const response = await fetch(
            finalEndpoint, {
                method: "GET"
            }
        )

        const result = await response.json();
        return result;
    }
}